export interface ScrollScope {
  readonly element: HTMLElement | Window;
  epoch: number;
}

export class ScrollScopeRegistry {
  readonly root: ScrollScope;
  private scopes = new Map<HTMLElement, ScrollScope>();

  constructor(rootElement: HTMLElement | Window) {
    this.root = { element: rootElement, epoch: 0 };
  }

  register(element: HTMLElement): ScrollScope {
    let scope = this.scopes.get(element);
    if (!scope) {
      scope = { element, epoch: 0 };
      this.scopes.set(element, scope);
    }
    return scope;
  }

  unregister(element: HTMLElement): void {
    this.scopes.delete(element);
  }

  bump(scope: ScrollScope): void {
    scope.epoch++;
  }

  bumpRoot(): void {
    this.root.epoch++;
  }

  resolveChain(element: HTMLElement): ScrollScope[] {
    const chain: ScrollScope[] = [];
    let node: HTMLElement | null = element.parentElement;
    while (node) {
      const scope = this.scopes.get(node);
      if (scope) chain.push(scope);
      node = node.parentElement;
    }
    chain.push(this.root);
    return chain;
  }

  static sumEpochs(chain: ScrollScope[]): number {
    let sum = 0;
    for (let i = 0; i < chain.length; i++) sum += chain[i].epoch;
    return sum;
  }
}
